// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see ScreenshottingCaptureTakeScreenshotEvent
 */
export var ScreenshottingCaptureTakeScreenshot = function (_a) {
    var viewController = _a.viewController, isPresentingAlert = _a.isPresentingAlert, isPresentingOptionsSheet = _a.isPresentingOptionsSheet;
    return ({
        name: "Screenshotting Capture TakeScreenshot",
        parameters: {
            cdf_entity: "Screenshotting",
            cdf_action: "Capture",
            view_controller: viewController !== undefined && viewController !== null ? viewController.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_presenting_alert: isPresentingAlert !== undefined && isPresentingAlert !== null ? isPresentingAlert.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_presenting_options_sheet: isPresentingOptionsSheet !== undefined && isPresentingOptionsSheet !== null ? isPresentingOptionsSheet.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see ScreenshottingScreenShareUpdateEvent
 */
export var ScreenshottingScreenShareUpdate = function (_a) {
    var state = _a.state;
    return ({
        name: "Screenshotting ScreenShare Update",
        parameters: {
            cdf_entity: "Screenshotting",
            cdf_action: "ScreenShare",
            state: state !== undefined && state !== null ? state.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
